<form autocomplete="off" [formGroup]="callDetailForm" style="margin-bottom: 20px;">
  <mat-form-field appearance="outline" fxFill>
    <mat-label>Prioridade do Chamado</mat-label>
    <mat-select
      (selectionChange)="priorityChanged()"
      formControlName="priority"
    >
      <mat-option value="B">Baixo</mat-option>
      <mat-option value="M">Médio</mat-option>
      <mat-option value="A">Alto</mat-option>
      <mat-option value="U">Urgente</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-divider></mat-divider>
  <br>

  <mat-form-field appearance="outline" fxFill>
    <mat-label>Tipo de Chamado</mat-label>
    <mat-select
      (selectionChange)="typeChanged()"
      formControlName="type"
    >
      <mat-option value="I">Incidente</mat-option>
      <mat-option value="D">Defeito</mat-option>
      <mat-option value="P">Problema</mat-option>
      <mat-option value="A">Solicitação de alteração</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-divider></mat-divider>

  <p>Descreva o <b>{{ statusNamed }}</b> reportado por <b>{{ _user != null ? _user.name : "Usuário" }}:</b></p>
  <ckeditor
    [config]="{
      toolbar: [
        'heading',
        '|',
        'bold',
        'italic',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        'undo',
        'redo'
      ]
    }"
    [editor]="descriptionEditor"
    (change)="saveEditorText($event)"
    ></ckeditor>
</form>
